import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgManagerEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#fff"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#000"
      d="m15.729 4.268.118.118a1.5 1.5 0 0 1 0 2.12l-9.312 9.312-2.766.528.527-2.767 9.311-9.311a1.5 1.5 0 0 1 2.122 0zm-8.646 8.649L12.5 7.5m-8.333 6.25c.833-.139 2.5.083 2.5 2.083M12.917 5c.833-.139 2.5.833 2.083 2.5"
    />
  </svg>
);
const Memo = memo(SvgManagerEdit);
export default Memo;
